import { render, staticRenderFns } from "./RedisCache.vue?vue&type=template&id=12640e2e"
import script from "./RedisCache.vue?vue&type=script&lang=js"
export * from "./RedisCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports